import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';

import Lenis from 'lenis';

const TRACKPAD_THRESHOLD = 10;

class SmoothScroll {
    constructor() {
        this._lenisConf = {
            duration: 0.5,
            easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            gestureDirection: 'vertical',
            smooth: true,
            smoothTouch: false,
            touchMultiplier: 1,
            wheelMultiplier: 1,
            prevent: (node) => {
                let classesToCheck = ['.cky-preference-body-wrapper', '.widget-container__trap .main'];
                let prevent = classesToCheck.some((className) => {
                    let parts = className.split(' ');
                    if (parts.length > 1) {
                        let parent = node.closest(parts[0]);
                        let targetClass = parts[1];
                        return (parent && parent.querySelector(targetClass)) || node.closest(targetClass);
                    }
                    return node.classList.contains(className.replace('.', '')) || node.closest(className);
                });
                return prevent;
            },
        };
        if (innerWidth >= screenSm) {
            this.lenis = new Lenis(this._lenisConf);
            this.lenis && this._run();
        }
    }
    _run = () => {
        const raf = (time) => {
            this.lenis.raf(time);
            requestAnimationFrame(raf);
        };

        requestAnimationFrame(raf);

        this._disableOnOpenModal();
        this._disableOnModalClose();
    };
    _disableOnOpenModal = () => {
        document.addEventListener('openmodal', () => {
            this.lenis.destroy();
        });
    };
    _disableOnModalClose = () => {
        document.addEventListener('modalclosed', () => {
            this.lenis.destroy();
            this.lenis = new Lenis(this._lenisConf);
            this._run();
        });
    };
    getScrollObject = () => {
        return this.lenis;
    };
}
const smoothScroll = new SmoothScroll();
export { smoothScroll };
